import { DefaultConfigValues } from "../utils/constants";

export const getServiceUrls = () => {
  if (process.env.NODE_ENV === "production") {
    return {
      FEE_SERVICE: `{REACT_APP_API_URL_PLACEHOLDER}feeservice`,
      USER_SERVICE: `{REACT_APP_API_URL_PLACEHOLDER}userservice`,
      TRIP_SERVICE: `{REACT_APP_API_URL_PLACEHOLDER}tripservice`,
      FBO_SERVICE: `{REACT_APP_API_URL_PLACEHOLDER}fboservice`,
      MESSAGING_SERVICE: `{REACT_APP_API_URL_PLACEHOLDER}messagingservice`,
      REACT_APP_KEYCLOAK_URL: `REACT_APP_KEYCLOAK_URL_PLACEHOLDER`,
      REACT_APP_KEYCLOAK_REALM: `REACT_APP_KEYCLOAK_REALM_PLACEHOLDER`,
      REACT_APP_KEYCLOAK_CLIENT_ID: `REACT_APP_KEYCLOAK_CLIENT_ID_PLACEHOLDER`,
      REACT_APP_VERSION: `REACT_APP_VERSION_PLACEHOLDER`,
      REACT_APP_SENTRY_DSN: `REACT_APP_SENTRY_DSN_PLACEHOLDER`,
      REACT_APP_PROFILE_ENV: `REACT_APP_PROFILE_ENV_PLACEHOLDER`,
    };
  }

  // For local development
  return {
    FEE_SERVICE: `${DefaultConfigValues.REACT_APP_API_URL}feeservice`,
    USER_SERVICE: `${DefaultConfigValues.REACT_APP_API_URL}userservice`,
    TRIP_SERVICE: `${DefaultConfigValues.REACT_APP_API_URL}tripservice`,
    FBO_SERVICE: `${DefaultConfigValues.REACT_APP_API_URL}fboservice`,
    MESSAGING_SERVICE: `${DefaultConfigValues.REACT_APP_API_URL}messagingservice`,
    REACT_APP_KEYCLOAK_URL: DefaultConfigValues.REACT_APP_KEYCLOAK_URL,
    REACT_APP_KEYCLOAK_REALM: DefaultConfigValues.REACT_APP_KEYCLOAK_REALM,
    REACT_APP_KEYCLOAK_CLIENT_ID:
      DefaultConfigValues.REACT_APP_KEYCLOAK_CLIENT_ID,
    REACT_APP_VERSION: DefaultConfigValues.REACT_APP_VERSION,
    REACT_APP_SENTRY_DSN: DefaultConfigValues.REACT_APP_SENTRY_DSN,
  };
};
